export default __webpack_public_path__ + "static/media/something-else.d46812fb.svg";